import { useMemo } from 'react';
import { msalInstance } from '../msal';
import { useGetAllWorkersQuery } from '../redux/rental';

/**
 * Get the user object for the logged in user
 *
 * null if user list is not fetched yet,
 * undefined if user not found
 */
export const useGetLoggedInRentalUserObject = () => {
  const { data: workers } = useGetAllWorkersQuery();
  const loggedInAccount = useMemo(() => (
    msalInstance.getActiveAccount()
  ), []);

  const loggedInUser = useMemo(() => {
    if (!workers) return null;
    return workers.find((e) => e.email === loggedInAccount?.username);
  }, [workers, loggedInAccount]);

  return loggedInUser;
};

// Continue to export old name
export {
  useGetLoggedInRentalUserObject as getLoggedInRentalUserObject,
};
